<template>
    <div class="uk-padding uk-margin-remove-top" >
        <div class="uk-container ">

      <!--      <h1 class="uk-text-left">
                <span class="half-a-border-on-top"></span>
            </h1>-->

            <!--<div class="uk-flex uk-flex-between">
                <div class="uk-float-left">
                    <p class="uk-text-small">See from our colleges and school how you can unlock your potential</p>
                </div>
                <div class="uk-float-right">
                    <a href="#" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                       style="margin-top: -10px; background-color: rgba(255, 215, 3,0.9); border-radius: 10px; color: #033860; font-size: medium"
                    >See Departments</a>
                </div>
            </div>-->
            <br>

            <div class="uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-3@l  " uk-grid >
                <div class="uk-align-center " style="margin: 0px !important; padding: 10px !important;">
                    <div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge" >
                        <router-link to="/arrangevisit">
                            <div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge" style=" height: 300px; background-image: url('/visit1.jpg');">
                                <div class="uk-padding"  :class="{ active: 'hover  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"
                                     @mouseover="hover = true"
                                     @mouseleave="hover = false"
                                >
                                    <div  v-if="!hover" class="">
                                        <h4 class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Schedule A Visit</h4>
                                        <!--<div >
                                            <button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>
                                        </div>-->
                                    </div>
                                    <div v-if="hover" style="margin: -15px">
                                        <h4 class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Schedule A Visit</h4>

                                        <!--<p class="uk-text-small">
                                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                            text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                        </p>
                                        <br>
                                        <a href="#" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right">View</a>
                                        <a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>-->
                                    </div>
                                    <!--<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                --></div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="uk-align-center uk-padding-remove"  style="margin: 0px !important; padding: 10px !important;">
                    <div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge" >
                        <a href="http://mec.ncu.edu.jm/" target="_blank">
                            <div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge" style=" height: 300px; background-image: url('/entrep.jpg');">
                                <div class="uk-padding"  :class="{ active: 'hover1  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"
                                     @mouseover="hover1 = true"
                                     @mouseleave="hover1 = false"
                                >
                                    <div  v-if="!hover1" class="">
                                        <h4  class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Entrepreneurship</h4>
                                        <!--<div >
                                            <button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>
                                        </div>-->
                                    </div>
                                    <div v-if="hover1" style="margin: -15px">
                                        <h4  class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Entrepreneurship</h4>

                                        <!--<p class="uk-text-small">
                                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                            text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                        </p>
                                        <br>
                                        <a href="#" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right">View</a>
                                        <a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>-->
                                    </div>
                                    <!--<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                --></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="uk-align-center uk-padding-remove" style="padding: 10px !important;margin: 0px !important;">
                    <div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge" >
                        <router-link to="/campusliving">
                            <div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge" style=" height: 300px; background-image: url('/campus_living.jpg');">
                                <div class="uk-padding"  :class="{ active: 'hover2  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"
                                     @mouseover="hover2 = true"
                                     @mouseleave="hover2 = false"
                                >
                                    <div  v-if="!hover2" class="">
                                        <h4  class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Living on Campus</h4>
                                        <!--<div >
                                            <button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>
                                        </div>-->
                                    </div>
                                    <div v-if="hover2" style="margin: -15px">
                                        <h4  class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Living on Campus</h4>

                                        <!--<p class="uk-text-small">
                                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                            text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                        </p>
                                        <br>
                                        <a href="#" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right">View</a>
                                        <a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>-->
                                    </div>
                                    <!--<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                --></div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="uk-align-center uk-padding-remove" style="padding: 10px !important; margin: 0px !important;">
                    <div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge" >
                        <router-link to="/scholarshipandstudentaid">
                            <div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge" style=" height: 300px; background-image: url('/aid.jpg');">
                                <div class="uk-padding"  :class="{ active: 'hover3  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"
                                     @mouseover="hover3 = true"
                                     @mouseleave="hover3 = false"
                                >
                                    <div  v-if="!hover3" class="">
                                        <h4  class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Student Aid</h4>
                                        <!--<div >
                                            <button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>
                                        </div>-->
                                    </div>
                                    <div v-if="hover3" style="margin: -15px">
                                        <h4  class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Student Aid</h4>

                                        <!--<p class="uk-text-small">
                                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                            text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                        </p>
                                        <br>
                                        <a href="#" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right">View</a>
                                        <a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>-->
                                    </div>
                                    <!--<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                --></div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="uk-align-center uk-padding-remove" style="padding: 10px !important; margin: 0px !important;">
                    <div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge" >
                        <router-link to="/onlineeducation">
                            <div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge" style=" height: 300px; background-image: url('/business.jpg');">
                                <div class="uk-padding"  :class="{ active: 'hover4  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"
                                     @mouseover="hover4 = true"
                                     @mouseleave="hover4 = false"
                                >
                                    <div  v-if="!hover4" class="">
                                        <h4  class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Online Learning</h4>
                                        <!--<div >
                                            <button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>
                                        </div>-->
                                    </div>
                                    <div v-if="hover4" style="margin: -15px">
                                        <h4  class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Online Learning</h4>

                                        <!--<p class="uk-text-small">
                                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                            text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                        </p>
                                        <br>
                                        <a href="#" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right">View</a>
                                        <a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>-->
                                    </div>
                                    <!--<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                --></div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <!--<div class="uk-align-center uk-padding-remove" style="padding: 10px !important; margin: 0px !important;">-->
                    <!--<div class="uk-card uk-card-default uk-card-hover uk-card-body uk-padding-remove smoothEdge" >-->
                        <!--<a href="#">-->
                            <!--<div class=" uk-background-cover uk-overflow-hidden uk-light uk-flex uk-flex-top smoothEdge" style=" height: 300px; background-image: url('/social_dev.jpg');">-->
                                <!--<div class="uk-padding"  :class="{ active: 'hover5  '}" style=" height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.7)"-->
                                     <!--@mouseover="hover5 = true"-->
                                     <!--@mouseleave="hover5 = false"-->
                                <!--&gt;-->
                                    <!--<div  v-if="!hover5" class="">-->
                                        <!--<h4  class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Social Development</h4>-->
                                        <!--&lt;!&ndash;<div >-->
                                            <!--<button class="uk-button uk-button-default uk-button-small uk-text-capitalize">View College</button>-->
                                        <!--</div>&ndash;&gt;-->
                                    <!--</div>-->
                                    <!--<div v-if="hover5" style="margin: -15px">-->
                                        <!--<h4  class="uk-text-center" style="color: rgba(255, 215, 3, 1); margin-top: 30%;">Social Development</h4>-->

                                        <!--&lt;!&ndash;<p class="uk-text-small">-->
                                            <!--Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy-->
                                            <!--text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.-->
                                        <!--</p>-->
                                        <!--<br>-->
                                        <!--<a href="#" class="uk-button uk-button-default uk-text-capitalize uk-margin-small-right">View</a>-->
                                        <!--<a href="#" class="uk-button uk-button-default uk-text-capitalize">Highlights</a>&ndash;&gt;-->
                                    <!--</div>-->
                                    <!--&lt;!&ndash;<p uk-parallax="opacity: 0,1; y: 100,0; scale: 0.5,1; viewport: 0.5;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>-->
                                <!--&ndash;&gt;</div>-->
                            <!--</div>-->
                        <!--</a>-->
                    <!--</div>-->
                <!--</div>-->

                <!--<div class="uk-align-center uk-padding-remove" style="padding: 10px !important; margin: 0px !important;"></div>
                <div class="uk-align-center uk-padding-remove" style="padding: 10px !important; margin: 0px !important;"></div>-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "undergradLinks",
        data() {
            return {
                hover: false,
                hover1: false,
                hover2: false,
                hover3: false,
                hover4: false,
                hover5: false,
            };
        }
    }
</script>

<style scoped>
    a{
        text-decoration: none;
    }
    .half-a-border-on-top {
        border-top: 2px solid gold;
        position: relative;
        color: #033860 ;

    }
    .half-a-border-on-top:after {
        padding-top: 10px;
        content: "";
        width:50%;
        height: 3px;/* slight higher to work around rounding errors(?) on some zoom levels in some browsers. */
        background-color: white;
        position: absolute;
        right:0;
        top:-2px;
    }
    .active {
        background-color: rgba(11, 11, 11,0.6) !important;

        transition: 1.0s;
        opacity: 1
    }
    .active:hover{
        opacity: 1;
        background-color: rgba(3, 56, 96,0.4) !important;
    }
    .active h4, .active button{
        color: #c0c0c0 !important;
        font-weight: bold;
    }
    .smoothEdge{
        border-radius: 5px;
    }
    @media screen and (max-width:600px){

        .uk-background-cover{
            height: 200px !important;
        }


    }
</style>
